"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Icon from "./icon.js";
export const DollarCircleIcon = React.forwardRef(function DollarCircleIcon(props, ref) {
    return (_jsxs(Icon, Object.assign({ ref: ref }, props, { children: [_jsx("path", { d: "M12 22a10 10 0 1 0 0-20 10 10 0 1 0 0 20z" }), _jsx("path", { d: "M12.05 6.15V18m2.693-9.695h-4.04c-.5 0-.98.199-1.333.552s-.552.833-.552 1.333a1.89 1.89 0 0 0 .552 1.333 1.88 1.88 0 0 0 1.333.552h2.693a1.89 1.89 0 0 1 1.333.552 1.88 1.88 0 0 1 .552 1.333 1.89 1.89 0 0 1-.552 1.333 1.88 1.88 0 0 1-1.333.552H8.818" })] })));
});
export default DollarCircleIcon;
//# sourceMappingURL=dollar-circle.js.map